import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/690a0c9f8dff8b0014626ac9/pneuma_fem_bible/src/app/bible-reader/components/BibleReaderClient.jsx");
